<template>
  <van-popup
    v-model="show"
    :overlay="false"
    z-index="2"
    position="bottom"
    :style="{ height: '100vh'}"
    :lock-scroll="false"
  >
    <div class="wrapper">
      <div class="block">
        <div class="button-close" @click="onCloseClick()">
          <img
            style="height: 19px"
            :src="require('../../../assets/imgs/icon/bottom-modal-close.png')"
          />
        </div>

        <div class="content-container">
          <div class="content-brief-container">
            <div
              class="content-brief-desc"
            >{{articleDetail.introduction}}</div>
            <div class="content-brief-title">文章导读</div>
          </div>

        <div v-if="articleDetail.videoUrl" class="video-container">
          <video
            id="videoid"
            style="
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px;
            "
            playsinline
            webkit-playsinline
            preload="load"
            autoplay="autoplay"
            controls="controls"
            x5-video-player-type="h5-page"
            :poster="
              articleDetail.videoUrl +
              '?x-oss-process=video/snapshot,t_1,f_jpg,w_600,h_0,m_fast'
            "
            :src="articleDetail.videoUrl"
          ></video>
        </div>
        <div
          v-if="!articleDetail.videoUrl && articleDetail.imageUrl"
          class="video-container"
        >
          <img class="article-intro-image" :src="articleDetail.imageUrl" />
        </div>
          <div style="height:50px;background-color: #fff"></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import * as ActionTypes from "../../../store/action-types";
import { mapState } from "vuex";

export default {
  name: "LevelSelectorModal",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {
        return {
          levels: [
            { name: "150L", desc: "适合：小升初、pet预备" },
            { name: "250L", desc: "适合：小升初、pet预备" },
            { name: "350L", desc: "适合：小升初、pet预备" },
            { name: "450L", desc: "适合：小升初、pet预备" },
            { name: "550L", desc: "适合：小升初、pet预备" },
            { name: "650L", desc: "适合：小升初、pet预备" },
            { name: "550L", desc: "适合：小升初、pet预备" },
            { name: "650L", desc: "适合：小升初、pet预备" },
          ],
        };
      },
    },
  },
  data() {
    return {
      //   show: true,
    };
  },
  computed:{
    ...mapState({
      articleDetail: (state) => state.article.articleDetail,
    }),
  },
  watch: {},
  methods: {
    onLevelSelect(levelItem) {
      console.log("=====>", levelItem);
      this.$store.dispatch(ActionTypes.READING_SWITCH_LEVEL, levelItem);
    },
    onCloseClick() {
      this.onClose();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #00000066;
}

.block {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  height: 70vh;
  width: 100%;
  padding-bottom: 50px;
  border-radius: 20px 20px 0 0;
}

.content-container {
  height: 100%;
  padding: 15px;
  text-align: center;
  overflow: auto;
}

.content-brief-container {
  display: flex;
}

.content-brief-desc {
  flex: 1;
  margin-right: 16px;
  margin-top: 50px;
  font-family: serif,SimSun,STSong;
}

.content-brief-title {
  text-align: center;
  width: 14px;
  font-size: 20px;
  line-height: 24px;
  font-family: Pangmeng;
}

.video-container {
  margin-top: 20px;
  background-color: #ffffff;
}

.article-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 11px;
  color: #999999;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.9);
}

.text-level-desc {
  margin-top: 10px;
  font-size: 12px;
  transform: scale(0.9);
  color: #333333;
}

.button-close {
  text-align: center;
  margin: 10px;
}
.article-intro-image {
  position: relative;
  width: 100%;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/BackgroundVideoModal.vue